import { Component, ChangeDetectionStrategy } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixComponent } from "../../prefix.component";
import { TemplateNumberComponent } from "../../templates/template-number/template-number.component";
import { Max } from "../../types/Max";
import { Min } from "../../types/Min";

@Component({
  selector: "app-prefix-jaa",
  imports: [TemplateNumberComponent],
  templateUrl: "./prefix-jaa.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./prefix-jaa.component.less",
})
export class PrefixJaaComponent extends PrefixComponent<string> {
  public min: Min;
  public max: Max;

  public constructor() {
    super({ updateOn: "blur" });
    this.min = 1900;
    this.max = 2500;
    this.characters = ALLOWED_CHARACTERS["jaa"];
  }
}
